module.exports = __webpack_public_path__ + "media/images/emblems/Hasle_LU-ca26f649540582e261f8f646aa229b26.png";